import axios from 'axios';
import { getErrorMessage, showErrorToast } from '../utils/toast';

export const FETCH_PROGRAM_REQUEST = 'FETCH_PROGRAM_REQUEST' as const;
export const FETCH_PROGRAM_SUCCESS = 'FETCH_PROGRAM_SUCCESS' as const;
export const FETCH_PROGRAM_FAILURE = 'FETCH_PROGRAM_FAILURE' as const;

export const FETCH_PROGRAM_WITH_ID_REQUEST = 'FETCH_PROGRAM_WITH_ID_REQUEST' as const;
export const FETCH_PROGRAM_WITH_ID_SUCCESS = 'FETCH_PROGRAM_WITH_ID_SUCCESS' as const;
export const FETCH_PROGRAM_WITH_ID_FAILURE = 'FETCH_PROGRAM_WITH_ID_FAILURE' as const;

export const FETCH_PROGRAM_STATS_REQUEST = 'FETCH_PROGRAM_STATS_REQUEST' as const;
export const FETCH_PROGRAM_STATS_SUCCESS = 'FETCH_PROGRAM_STATS_SUCCESS' as const;
export const FETCH_PROGRAM_STATS_FAILURE = 'FETCH_PROGRAM_STATS_FAILURE' as const;

export const FETCH_PROCESSORS_REQUEST = 'FETCH_PROCESSORS_REQUEST' as const;
export const FETCH_PROCESSORS_SUCCESS = 'FETCH_PROCESSORS_SUCCESS' as const;
export const FETCH_PROCESSORS_FAILURE = 'FETCH_PROCESSORS_FAILURE' as const;

export const CLEAR_STORE = 'CLEAR_STORE' as const;

export const clearStoreAction = () => ({
  type: CLEAR_STORE,
});

export const fetchPrograms = (principalId: number | string) => async (dispatch: any) => {
  dispatch({ type: FETCH_PROGRAM_REQUEST });
  try {
    const token = localStorage.getItem('accessToken');
    const response = await axios.request({
      baseURL: `${window.env.API_URL}/v1/programs/programs/?principalId=${principalId}`,
      timeout: 10000000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      method: 'GET',
    });

    dispatch({ type: FETCH_PROGRAM_SUCCESS, payload: response.data });
  } catch (error: any) {
    const msg = getErrorMessage(error, 'Failed to load programs');
    dispatch({ type: FETCH_PROGRAM_FAILURE, error: msg });
    showErrorToast(msg);
  }
};

export const fetchProgramWithId = (programId: number | string) => async (dispatch: any) => {
  dispatch({ type: FETCH_PROGRAM_WITH_ID_REQUEST });
  try {
    const token = localStorage.getItem('accessToken');
    const response = await axios.request({
      baseURL: `${window.env.API_URL}/v1/programs/programs/${programId}`,
      timeout: 10000000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      method: 'GET',
    });

    dispatch({ type: FETCH_PROGRAM_WITH_ID_SUCCESS, payload: response.data });
  } catch (error: any) {
    const msg = getErrorMessage(error, 'Failed to load program');
    dispatch({ type: FETCH_PROGRAM_WITH_ID_FAILURE, error: msg });
    showErrorToast(msg);
  }
};

export const fetchProgramStats = () => async (dispatch: any) => {
  dispatch({ type: FETCH_PROGRAM_STATS_REQUEST });
  try {
    const token = localStorage.getItem('accessToken');
    const response = await axios.request({
      baseURL: `${window.env.API_URL}/v1/programs/programs/stats`,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      method: 'GET',
    });
    dispatch({ type: FETCH_PROGRAM_STATS_SUCCESS, payload: response.data });
  } catch (error: any) {
    const msg = getErrorMessage(error, 'Failed to load dashboard stats');
    dispatch({ type: FETCH_PROGRAM_STATS_FAILURE, error: msg });
    showErrorToast(msg);
  }
};

/**
 * Lists available payment processors (same contract as admin-portal ProgramSlice.fetchProcessorList).
 * GET {API_URL}/v1/programs/processors
 * Response: { processors: Processor[] } (processors key required by current backend).
 */
export const fetchProcessors = () => async (dispatch: any) => {
  dispatch({ type: FETCH_PROCESSORS_REQUEST });
  try {
    const token = localStorage.getItem('accessToken');
    const response = await axios.request({
      baseURL: `${window.env.API_URL}/v1/programs/processors`,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      method: 'GET',
    });
    const raw = response.data?.processors;
    const list = Array.isArray(raw) ? raw : [];
    dispatch({ type: FETCH_PROCESSORS_SUCCESS, payload: list });
  } catch (error: any) {
    const msg = getErrorMessage(error, 'Failed to load processors');
    dispatch({ type: FETCH_PROCESSORS_FAILURE, error: msg });
    showErrorToast(msg);
  }
};

